<template>

    <v-navigation-drawer permanent expand-on-hover>

        <v-list>

            <v-list-item class="px-2" style="height: 75px;">

                <v-list-item-avatar>
                    <v-img src="https://randomuser.me/portraits/men/9.jpg"></v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                    <v-list-item-title class="title">
                        {{user.lastName}} {{user.firstName}}
                    </v-list-item-title>
                    <v-list-item-subtitle>{{user.email}}</v-list-item-subtitle>
                </v-list-item-content>

            </v-list-item>

        </v-list>

        <v-divider></v-divider>

        <v-list nav dense class="sidebar-list">

          <!-- account info -->
          <router-link to="/account">
            <v-list-item link>
              <v-list-item-icon>
                <v-icon class="indigo--text">{{ $t("client.account.icon")}}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ $t("client.account.title")}}</v-list-item-title>
            </v-list-item>
          </router-link>

            <!-- create tenant -->
            <router-link v-if="user.isSuperAdmin" to="/sadmin/create-tenant">
                <v-list-item link>
                    <v-list-item-icon>
                        <v-icon class="indigo--text">{{$t("sadmin.tenant_create.icon")}}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{ $t("sadmin.tenant_create.title") }}</v-list-item-title>
                </v-list-item>
            </router-link>

            <!-- tenant list -->
            <router-link v-if="user.isSuperAdmin" to="/sadmin/tenants">
                <v-list-item link>
                    <v-list-item-icon>
                        <v-icon class="indigo--text">{{ $t("sadmin.tenant_list.icon")}}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{ $t("sadmin.tenant_list.title")}}</v-list-item-title>
                </v-list-item>
            </router-link>

            <!-- email server settings -->
            <router-link v-if="user.isSuperAdmin" to="/sadmin/email-settings">
              <v-list-item link>
                <v-list-item-icon>
                  <v-icon class="indigo--text">{{ $t("sadmin.email_server_config.icon")}}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ $t("sadmin.email_server_config.title")}}</v-list-item-title>
              </v-list-item>
            </router-link>



          <router-link to="/checkin" v-if="user.isClient">
            <v-list-item link>
              <v-list-item-icon>
                <v-icon class="indigo--text">mdi-check-all</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Check-in</v-list-item-title>
            </v-list-item>
          </router-link>

            <router-link to="/locations" v-if="user.isClient">
                <v-list-item link>
                    <v-list-item-icon>
                        <v-icon class="indigo--text">{{ $t("client.locations.icon")}}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{ $t("client.locations.title")}}</v-list-item-title>
                </v-list-item>
            </router-link>

          <router-link  v-if="user.isAdmin" to="/admin/agencies">
            <v-list-item link>
              <v-list-item-icon>
                <v-icon class="indigo--text">mdi-domain</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ $t("admin.agencies.title")}}</v-list-item-title>
            </v-list-item>
          </router-link>

          <router-link  v-if="user.isSuperAdmin" to="/sadmin/global-ui-config">
            <v-list-item link>
              <v-list-item-icon>
                <v-icon class="indigo--text">mdi-material-ui</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ $t("sadmin.global_ui_config.title")}}</v-list-item-title>
            </v-list-item>
          </router-link>

          <router-link  v-if="user.isAdmin" to="/admin/activities">
            <v-list-item link>
              <v-list-item-icon>
                <v-icon class="indigo--text">mdi-human-handsup</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ $t("shared.activities.title")}}</v-list-item-title>
            </v-list-item>
          </router-link>

        </v-list>

    </v-navigation-drawer>

</template>

<script>
export default {
    name: 'Sidebar',
    props:{
        user: null
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.v-navigation-drawer {
    position: absolute;
    min-height: 100vh;
    left: 0;
    right: 0;
    background-color: white;
}
.sidebar-list a{
  text-decoration: none;
}
</style>
